  <div class="container">
    <header class="header-between">
      <app-logo class="logo-pages"></app-logo>
      <app-search-bar></app-search-bar>
    </header>

    <section>
        <h1>User not found :(</h1>
    </section>
  </div>

